import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomPartyOption} from '../../../graphql/groups.datatypes';

export interface CreateRoomPartyOptionInput {
    data: {
        room_party_id: number
        group_resource_option_id: number
        unit_count: number
        unit_cost: number
        admin_edited: boolean
    }
}

interface CreateRoomPartyOptionData {
    createRoomPartyOption: RoomPartyOption,
}

export const CREATE_ROOM_PARTY_MEMBER_OPTION_MUTATION = gql`
  mutation createRoomPartyOption($data: CreateRoomPartyOptionInput!){
    createRoomPartyOption(data: $data) {
      id
      room_party_id
      group_resource_option_id
      unit_count
      unit_cost
      admin_edited
    }
  }
`;

export const createRoomPartyOption = () => {
    return useMutation<CreateRoomPartyOptionData, CreateRoomPartyOptionInput>(
        CREATE_ROOM_PARTY_MEMBER_OPTION_MUTATION,
        {
            update: updateCacheByType('RoomPartyOption'),
        }
    );
};

export default createRoomPartyOption;